export var mobilePhoneRegExp = /^\d{10}$/;
